import React from 'react';
import { connect } from 'react-redux';
import { Header, Modal, Grid, Form, Select, Checkbox, Button, Label } from 'semantic-ui-react';
import { hideSiteDetailsModal } from '../../redux/actions/modals';
import RefreshSlider from '../shared/RefreshSlider';
import DetailsButton from '../shared/DetailsButton';
import ExpandButton from '../shared/ExpandButton';
import DataGrid from '../shared/DataGrid';
import SiteDetailsFilters from '../LiveFloorViewer/SiteDetailsFilters';

const defaultGrid = { span: [], headerDef: [], rowDef: [], data: [], online: 0, offline: 0, siteDisplay: "" }
const defaultRow = { installationId: null }
class SiteDetailsModal extends React.Component {

  state = {
    selectedPeriod: 1,
    showEvents: false,
    loadingPositions: false,
    loadingEvents: false,
    grid: defaultGrid,
    events: defaultGrid,
    hideDetails: false,
    siteDisplay: "",
    activeRow: defaultRow,
    offlineOnly: false
  }
  
  componentDidUpdate(prevProps) {
    if (!prevProps.modal.open && this.props.modal.open) {
      this.handleRefresh();
    }
  }

  onClose = () => this.props.hideSiteDetailsModal()
  
  handleRefresh = () => {
    const { positionsFn, siteId } = this.props.modal;
    const { offlineOnly } = this.state;
    this.setState({ activeRow: defaultRow, loadingPositions: true }, () => {
      positionsFn(siteId, offlineOnly).then(
        grid => this.setState({ grid, loadingPositions: false, activeRow: defaultRow, events: defaultGrid }),
        () => this.setState({ loadingPositions: false, grid: defaultGrid })
      )
    })
  }
  
  handleRefreshEvents = () => {
    const { eventsFn } = this.props.modal;
    const { activeRow, selectedPeriod, showEvents } = this.state;
    const { installationId } = activeRow
    
    this.setState({ loadingEvents: true }, () => {
      eventsFn(installationId, selectedPeriod, showEvents).then(
        events => this.setState({ events, loadingEvents: false }),
        () => this.setState({ loadingEvents: false, events: defaultGrid })
      );
    })
  }

  render() {

    const { title, open } = this.props.modal;
    const { offlineOnly } = this.state;
    const { hideDetails, events, grid, loadingPositions, loadingEvents, activeRow } = this.state;

    return (
        <Modal
            open={open}
            onClose={this.onClose}
            size='large'
            closeIcon
            className="h-80"
        >
          <Modal.Header>{title || "Cash In Box"}</Modal.Header>
          <Modal.Content className="h-100 gs-flex-container-vertical">
            <Grid className="h-100 gs-flex-container-vertical">
              <Grid.Row>
                <Grid.Column width="8" verticalAlign="middle">
                  <Header size="small">{grid.siteDisplay}</Header>
                  <Label color='green' content='Online' detail={grid.online} />
                  <Label color='red' content='Offline' detail={grid.offline} />
                  <Checkbox label='Show Offline Only' value={offlineOnly} onChange={() => this.setState({ offlineOnly: !offlineOnly })} />
                </Grid.Column>
                <Grid.Column width="8" textAlign="right">
                  <RefreshSlider size="medium" compact={false} refresh={this.handleRefresh} />
                  <ExpandButton compact={false} size="medium"  content="Hide Details" onClick={() => this.setState({ hideDetails: !hideDetails })} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="flex-stretch">
                <Grid.Column width="16" stretched>
                  <DataGrid
                    groupHeadings={grid.span}
                    headings={grid.headerDef}
                    data={grid.data}
                    rowDef={grid.rowDef}
                    loading={loadingPositions}
                    onRowClick={activeRow => this.setState({ activeRow }, () => this.handleRefreshEvents())}
                    hideOverflow
                    disableSort
                    fullHeight
                  />
                </Grid.Column>
              </Grid.Row>
              { !hideDetails && 
              <>
                <Grid.Row>
                  <Grid.Column width="16">
                    <SiteDetailsFilters
                      {...this.state}
                      onRefreshClick={this.handleRefreshEvents}
                      disabled={activeRow.installationId === null}
                      onChange={(event, { name, value }) => this.setState({ [name]: value })}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="flex-stretch">
                  <Grid.Column width="16" stretched>
                    <DataGrid
                      headings={events.headerDef}
                      data={events.data}
                      rowDef={events.rowDef}
                      loading={loadingEvents}
                      hideOverflow
                      disableSort
                      fullHeight
                    />
                  </Grid.Column>
                </Grid.Row>
              </>
              }
            </Grid>
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.siteDetailsModal,
  };
};

export default connect(mapStateToProps, { hideSiteDetailsModal })(SiteDetailsModal);


